import Vue from 'vue';
import Vuex from 'vuex';
import fpsState from '@fps/vue-toolkit/dist/store';
import fpsStateAuth from '@fps/vue-toolkit/dist/store/auth';
import fpsStateTemp from '@fps/vue-toolkit/dist/store/temp';
import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import auth from './auth';
import temp from './temp';
import ads from './ads';
import filters from './filters';
import { getConfig } from '@/utils'
const config = getConfig()

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    auth: {
      state: { ...fpsStateAuth.state, ...auth.state },
      actions: { ...fpsStateAuth.actions, ...auth.actions },
      mutations: { ...fpsStateAuth.mutations, ...auth.mutations },
      getters: { ...fpsStateAuth.getters, ...auth.getters },
    },
    temp: {
      state: { ...fpsStateTemp.state, ...temp.state },
      actions: { ...fpsStateTemp.actions, ...temp.actions },
      mutations: { ...fpsStateTemp.mutations, ...temp.mutations },
      getters: { ...fpsStateTemp.getters, ...temp.getters },
    },
    filters,
    ads,
  },
  state: { ...fpsState.state, ...state, config },
  actions: { ...fpsState.actions, ...actions },
  mutations: { ...fpsState.mutations, ...mutations },
  getters: { ...fpsState.getters, ...getters },
});



// WEBPACK FOOTER //
// ./src/store/index.js